import { getPluginSelector } from 'reducers/Plugins';

import { SET_PURCHASE_ORDER } from './actionTypes';

type HpState = {
  purchaseOrderNumber: string;
};

const hpReducer = (
  state = {
    purchaseOrderNumber: '',
  },
  action,
): HpState => {
  switch (action.type) {
    case SET_PURCHASE_ORDER:
      return { ...state, purchaseOrderNumber: action.payload };
    default:
      return state;
  }
};

export const getHipPocketState = state =>
  getPluginSelector<HpState>('hip-pocket-plugin')(n => n)(state);

export default hpReducer;
